import type { SourceResult } from '../engine';
import type { ZoneNumber } from '../model/types';

/** The zone a source's chip shows: the most severe drawn zone, or NE, or nothing. */
export function chipZone(r: SourceResult | undefined): ZoneNumber | 'ne' | null {
  if (!r) return null;
  if (r.volumes.length) return Math.min(...r.volumes.map((v) => v.zone)) as ZoneNumber;
  if (r.negligible !== undefined) return 'ne';
  return null;
}

export const GRADE_LABEL = { continuous: 'Continuous', primary: 'Primary', secondary: 'Secondary' } as const;
export const GRADE_SHORT = { continuous: 'C', primary: 'P', secondary: 'S' } as const;
export const FORM_LABEL = { diffusive: 'Diffusive', heavy: 'Heavy gas', jet: 'Jet' } as const;
export const MODEL_LABEL = { gas: 'Gas under pressure', liquid: 'Liquid under pressure', pool: 'Evaporating pool', manual: 'Entered release rate' } as const;
export const cap = (s: string | undefined) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '—');

export function worstSeverity(issues: Array<{ severity: 'error' | 'warning' | 'info' }>): 'error' | 'warning' | 'info' | null {
  if (issues.some((i) => i.severity === 'error')) return 'error';
  if (issues.some((i) => i.severity === 'warning')) return 'warning';
  if (issues.some((i) => i.severity === 'info')) return 'info';
  return null;
}
